<template>
  <section class="ryzz" id="ryzz">
    <div class="section">
      <div class="desc-title"><span class="active">{{ $t('honorSection.title') }}</span><span> / {{ $t('honorSection.subTitle') }}</span></div>
      <div class="tabs">
        <button :class="['tab', { active: tab === 'honor' }]" @click="tab = 'honor'">{{ $t('honorSection.tabHonor') }}</button>
        <button :class="['tab', { active: tab === 'cert' }]" @click="tab = 'cert'">{{ $t('honorSection.tabCert') }}</button>
      </div>
    </div>
    <HonorSwiper :items="tab === 'honor' ? honorItems : certItems" />
  </section>
</template>

<script>
import HonorSwiper from './HonorSwiper.vue'

export default {
  name: 'HonorSection',
  components: { HonorSwiper },
  computed: {
    honorItems() {
      return this.honorList.map(item => ({ ...item, title: this.$t(item.titleKey) }))
    },
    certItems() {
      return this.certList.map(item => ({ ...item, title: this.$t(item.titleKey) }))
    }
  },
  data() {
    return {
      tab: 'honor',
      honorList: [
        { image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/index/8.png', titleKey: 'honorSection.honor1' },
        { image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/c1092e93-029c-401f-9fd2-6b2ae0197a99.jpg', titleKey: 'honorSection.honor2' },
        { image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/index/2.png', titleKey: 'honorSection.honor3' },
        { image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/web/index/9.jpg', titleKey: 'honorSection.honor4' },
        { image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/8faef049-cd06-4ea5-8b3a-e8e881bfdd79.jpg', titleKey: 'honorSection.honor5' },
        { image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/839196ce-ea9f-43be-8d3a-e8f579c5b759.jpg', titleKey: 'honorSection.honor6' }
      ],
      certList: [
        { image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/823fd75b-b565-4281-b498-94623565c626.jpg', titleKey: 'honorSection.cert1' },
        { image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/90b2e410-d8db-421d-a1b5-e6d1398eee64.jpg', titleKey: 'honorSection.cert2' },
        { image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/e6107826-361e-4d66-82cc-c346961f128d.jpg', titleKey: 'honorSection.cert3' },
        { image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/be287277-b0d6-4458-bfe1-7b7ef6bdf8a0.jpg', titleKey: 'honorSection.cert4' },
        { image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/4a2bf402-275e-4dd4-980d-f75e9817c593.jpg', titleKey: 'honorSection.cert5' },
        { image: 'https://xdxdd-1257088705.cos.ap-guangzhou.myqcloud.com/images/7d142d34-66d8-4303-8cbe-98cf59eb3ddb.jpg', titleKey: 'honorSection.cert6' }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.ryzz { background: #f7faff; padding-top: 40px; }
.section { width: 1200px; margin: 0 auto; }
.desc-title { text-align: center; color: #929292; }
.desc-title .active { color: #1c51a3; font-size: 26px; }
.tabs { width: 302px; margin: 32px auto 0; display: flex; justify-content: space-between; }
.tab { width: 120px; height: 38px; border: none; background: transparent; color: #666; cursor: pointer; }
.tab.active { background: #1c51a3; color: #fff; border-radius: 38px; }
</style>
